export const SUPPORTED_LANGUAGES = [
    { code: 'en-GB', label: 'English (UK)' },
    { code: 'en-US', label: 'English (US)' },
    { code: 'en-AU', label: 'English (Australian)' },
    { code: 'es', label: 'Spanish' },
    { code: 'fr', label: 'French' },
    { code: 'de', label: 'German' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'pt-BR', label: 'Portuguese (Brazilian)' },
    { code: 'it', label: 'Italian' },
    { code: 'nl', label: 'Dutch' },
    { code: 'pl', label: 'Polish' },
    { code: 'sv', label: 'Swedish' },
    { code: 'da', label: 'Danish' },
    { code: 'no', label: 'Norwegian' },
    { code: 'ja', label: 'Japanese' },
    { code: 'ko', label: 'Korean' },
    { code: 'zh', label: 'Chinese (Simplified)' },
    { code: 'ar', label: 'Arabic' },
    { code: 'hi', label: 'Hindi' },
    { code: 'tr', label: 'Turkish' },
];
export const LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);
export const DEFAULT_LANGUAGE = 'en-GB';
export const LANGUAGE_LABELS = Object.fromEntries(SUPPORTED_LANGUAGES.map((l) => [l.code, l.label]));
//# sourceMappingURL=languages.js.map